// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1wkTe","requiredAsterisk":"Info_requiredAsterisk__1I90N"};